import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDocsSecurePage } from './program-docs-secure';

@NgModule({
  declarations: [
    ProgramDocsSecurePage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDocsSecurePage),
  ],
})
export class ProgramDocsSecurePageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-docs-secure/program-docs-secure.module.ts